import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, AsyncSubject, of } from 'rxjs';
import { Router } from '@angular/router';

import { CurrentUser } from './../dataTypes/CurrentUser';
import { UserPermission } from './../dataTypes/UserPermission';

import * as _ from 'lodash';

@Injectable()
export class AuthService {

  public authToken: BehaviorSubject<string> = new BehaviorSubject('');
  authToken$ = this.authToken.asObservable();

  public userModel: BehaviorSubject<CurrentUser> = new BehaviorSubject(new CurrentUser());
  userModel$ = this.userModel.asObservable();

  public userPermissions: AsyncSubject<UserPermission[]> = new AsyncSubject<UserPermission[]>();
  userPermissions$ = this.userPermissions.asObservable();

  public loggedIn = false;
  public refreshToken: string;
  public timestampLogin: number;
  public expire: number;
  public started: boolean;

 // public url = (<any>window).appSettings.authUrl + '/OAuth/Token';

  constructor(public http: HttpClient, public _router: Router) {

  }

  login(username, password): Observable<object> {

    this.started = false;

    if ((<any>window).appSettings.startConfiguration) {
      if (username === 'Administrator' && password === 'Administrator123$%^9999') {
        //if (username === '1' && password === '1') {
        this.loggedIn = true;
        const timestampLogin = new Date().getTime();
        localStorage.setItem('auth_token', '1');
        localStorage.setItem('refresh_token', '1');
        localStorage.setItem('timestampLogin', timestampLogin + '');
        localStorage.setItem('expire', 72000 + '');
        this.authToken.next('1');
        this.refreshToken = '1';
        this.expire = 72000;
        this.timestampLogin = timestampLogin;
        return of(null);
      } else {
        return of(null);
      }
    } else {
      const self = this;
      const data = { grant_type: 'password', username: username, password: password };
      const str = Object.keys(data).map(function (key) {
        return key + '=' + data[key];
      }).join('&');


      //let reqHeader = new HttpHeaders({
      //  'Content-Type': 'application/x-www-form-urlencoded',
      //});

      //return self.http.post(self.url, str, { headers: reqHeader })
      //  .subscribe((response: Response) => {

      //    var res = response.json();
      //    console.debug(res);

      //    let success: boolean = false;

        //  if (!res.error) {
        //    const timestampLogin = new Date().getTime();
        //    localStorage.setItem('auth_token', res.access_token);
        //    localStorage.setItem('refresh_token', res.refresh_token);
        //    localStorage.setItem('timestampLogin', timestampLogin + '');
        //    localStorage.setItem('expire', res.expires_in + '');
        //    self.authToken.next(res.access_token);
        //    self.refreshToken = res.refresh_token;
        //    self.expire = res.expire;
        //    self.timestampLogin = timestampLogin;

        //    self.loggedIn = true;
        //    success = true;
        //  }
        //  return success;


        //}).catch(function (error: Response | any) {
        //  let errMsg: string;
        //  if (error instanceof Response) {
        //    const body = error.json() || '';
        //    const err = body.error || JSON.stringify(body);
        //    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        //  } else {
        //    errMsg = error.message ? error.message : error.toString();
        //  }
        //  console.error(errMsg);
        //  return Observable.throw(errMsg);
          //
        //}
        //  );
    }
  }

  //refresh() {
    //if ((<any>window).appSettings.startConfiguration) {
    //  const timestampLogin = new Date().getTime();
    //  localStorage.setItem('timestampLogin', timestampLogin + '');
    //  return Observable.of('1');
    //} else {
    //  const self = this;
    //  const data = { grant_type: 'refresh_token', refresh_token: localStorage.getItem('refresh_token') };
    //  const str = Object.keys(data).map(function (key) {
    //    return key + '=' + data[key];
    //  }).join('&');

    //  let reqHeader = new HttpHeaders({
    //    'Content-Type': 'application/x-www-form-urlencoded',
    //  });


    //  return this.http.post(
    //    this.url,
    //    str,
    //    { headers: reqHeader }
    //  )
    //    .map(res => res.json())
    //    .map((res) => {
    //      if (!res.error) {
    //        const timestampLogin = new Date().getTime();
    //        localStorage.setItem('auth_token', res.access_token);
    //        localStorage.setItem('refresh_token', res.refresh_token);
    //        localStorage.setItem('timestampLogin', timestampLogin + '');
    //        localStorage.setItem('expire', res.expires_in + '');
    //        self.authToken.next(res.access_token);
    //        self.refreshToken = res.refresh_token;
    //        self.expire = res.expire;
    //        self.timestampLogin = timestampLogin;
    //        console.log('new refresh token: ' + res.refresh_token)
    //        self.loggedIn = true;
    //      } else {
    //        console.log('refresh token error 1');
    //        localStorage.removeItem('auth_token');
    //        localStorage.removeItem('refresh_token');
    //        localStorage.removeItem('timestampLogin');
    //        localStorage.removeItem('expire');
    //        location.reload();
    //      }

    //      return res.access_token;
    //    }).catch(function (error: Response | any) {
    //      let errMsg: string;
    //      if (error instanceof Response) {
    //        const body = error.json() || '';
    //        const err = body.error || JSON.stringify(body);
    //        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    //      } else {
    //        errMsg = error.message ? error.message : error.toString();
    //      }
    //      window.location.replace('/login');
    //      return Observable.throw(errMsg);
    //    });
    //}

  //}

  logout() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('timestampLogin');
    localStorage.removeItem('expire');

    localStorage.clear();
    this.loggedIn = false;
    this.started = false;
    location.reload();
    //this._router.navigate([''])
  }

  isTokenNotExpired() {
    if (new Date().getTime() - parseInt(localStorage.getItem('timestampLogin')) < parseInt(localStorage.getItem('expire')) * 1000) {
      return true;
    } else {
      return false;
    }
  }

  getUserPermissions(cb?) {
    //const self = this;
    //if ((<any>window).appSettings.startConfiguration) {
    //  let permissionsArray: UserPermission[] = [];
    //  permissionsArray.push(new UserPermission(1, 1, 2, '', 'SystemWebConfiguration'))
    //  this.userPermissions.next(permissionsArray);
    //  this.userPermissions.complete();
    //  if (cb) {
    //    cb();
    //  }
    //} else {
    //  self.getAuthToken().subscribe(authToken => {
    //    self.userModel$.subscribe(userModel => {
    //      if (!userModel.Id) {
    //        return;
    //      }


    //      let reqHeader = new HttpHeaders({
    //        'Content-Type': 'application/json',
    //        'Authorization': 'Bearer ' + authToken
    //      });



    //      self.http.get(
    //        (<any>window).appSettings.dataUrl + '/api/UserPermissions/?userID=' + userModel.Id,
    //        { headers: reqHeader }
    //      )
    //        .map((response: Response) => { return { status: response.status, jsonString: <string>response.json() }; })
    //        .catch(function (error: Response | any) {
    //          let errMsg: string;
    //          if (error instanceof Response) {
    //            const body = error.json() || '';
    //            const err = body.error || JSON.stringify(body);
    //            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    //          } else {
    //            errMsg = error.message ? error.message : error.toString();
    //          }
    //          console.log(errMsg);
    //          window.location.replace('/login');
    //          return Observable.throw(errMsg);
    //        }).subscribe((data) => {
    //          console.log(data)
    //          let permissionsArray: UserPermission[] = [];
    //          _.each(data.jsonString, (elem: any) => {
    //            permissionsArray.push(new UserPermission(elem.permissionFromRole, elem.resourceID, elem.resourceLevel, elem.resourceNameLocalized, elem.resourceName))
    //          });
    //          self.userPermissions.next(permissionsArray);
    //          self.userPermissions.complete();
    //          if (cb) {
    //            cb();
    //          }
    //        });
    //    });
    //  });
    //}
  }
  // FOR OVERRIDE ONLY
  getUserInfo() {
    
  }

  getAuthToken() {
    if (this.isTokenNotExpired()) {
      return this.authToken$;
    } else {
      return new Observable<string>(); //this.refresh();
    }
  }

  isLoggedIn() {
    if (!this.started) {
      return this.init();
    }
    return this.loggedIn;
  }

  init(login?) {
    //console.log('init')
    //this.started = true;
    //const self = this;
    //this.authToken.next(localStorage.getItem('auth_token'));
    //this.refreshToken = localStorage.getItem('refresh_token');
    //this.expire = parseInt(localStorage.getItem('expire'), 10);
    //this.timestampLogin = parseInt(localStorage.getItem('timestampLogin'), 10);
    //if (!localStorage.getItem('auth_token')) {
    //  this.loggedIn = false;
    //} else {
    //  if (this.isTokenNotExpired()) {
    //    this.loggedIn = true;
    //    this.getUserInfo();
    //    this.getUserPermissions(() => {
    //      if (login === true) {
    //        this.redirectAfterLogin();
    //      }
    //    });
    //  } else if (localStorage.getItem('refresh_token')) {
    //    this.refresh().subscribe(access_token => {
    //      if (access_token) {
    //        this.loggedIn = true;
    //        this.getUserInfo();
    //        this.getUserPermissions(() => {
    //          this.redirectAfterLogin();
    //        });
    //      }
    //    });
    //  } else {
    //    this.loggedIn = false;
    //    window.location.replace('/login');
    //  }
    //}
    //this.loggedIn = this.isTokenNotExpired();
    //return this.loggedIn;
  }

  redirectAfterLogin() {

  }
}
